import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import AppointmentBar from '../OurDoctors/AppointmentBar';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { sendQuickOtp, quickRegister, verifyOtp } from '../../api/auth.api';
import { isMobileVerified, storePatientSession } from '../../utils/storage/authStorage';
import { Notification } from '../../utils';
import { API_BASE_URL } from '../../config';
import { VerifiedIcon } from '../Home/Testimonals';
export const SectionWrapper = ({ children, heading }) => {
  return (
    <div className=" container mx-auto px-4 md:px-8 w-full pb-10 md:pb-14 pt-4">
      <p className="ava-heading-lg   ava-heading-gap "
        style={{ paddingLeft: "2rem" }}
      >{heading}</p>
      {children}
    </div>
  )
}

const BookAppointment = ({ data, autoOpenRef }) => {
  // console.log("mountttttted", data);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const CLINIC_ID = '6a352e39ab22c07f82b4261a';
  const BASE_URL = 'https://api.avexa.net/clinic-onboarding';
  const [searchParams, setSearchParams] = useSearchParams();
  const autoRef = useRef(null);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  


  useEffect(() => {
    setLoading(true);
    const fetchProviders = async () => {
      try {
        // Step 1: fetch providers list
        const res = await fetch(`${BASE_URL}/clinics/${CLINIC_ID}/providers`);
        if (!res.ok) throw new Error('Failed to fetch providers');
        const data = await res.json();
        const providerList = data.providers ?? [];

        // Step 2: for each provider, fetch their profile using providerId
        const enriched = await Promise.all(
          providerList.map(async (provider) => {
            try {
              const profileRes = await fetch(
                `${BASE_URL}/clinics/${CLINIC_ID}/providers/${provider.providerId}/onboarding/profile`
              );
              if (!profileRes.ok) return provider; // fallback to base data if profile fails
              const profile = await profileRes.json();
              return { ...provider, ...profile }; // merge profile into provider
            } catch {
              return provider; // fallback silently
            }
          })
        );

        setProviders(enriched);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, []);
  const handleClose = () => { setSelectedDoctor(null); setSearchParams({}) };

  // useEffect(() => {
  //   const shouldOpen = searchParams.get("openModal") === "true";
  //   const doctorId = searchParams.get("doctorId");
  //   if (shouldOpen) {
  //     const timer = setTimeout(() => {
  //       autoOpenRef.current?.(doctorId);
  //     }, 100);
  //     return () => clearTimeout(timer);
  //   }
  // }, [searchParams])
useEffect(() => {
  const shouldOpen = searchParams.get("openModal") === "true";
  const doctorId = searchParams.get("doctorId");
  if (shouldOpen && !loading && providers.length > 0) {
    const timer = setTimeout(() => {
      autoOpenRef.current?.(doctorId);
    }, 100);
    return () => clearTimeout(timer);
  }
}, [searchParams, loading, providers]);

  // useEffect(() => {
  //   if (autoOpenRef && data?.doctors?.length > 0) {
  //     autoOpenRef.current = (doctorId) => {
  //       console.log(data, "thi si sthe data we r searching for");
  //       const matchedDoctor = data.doctors.find(
  //         (doc) => {
  //           console.log(doc, "thiis is the particular doc", doctorId, doc.id === doctorId);
  //           return String(doc.id) === String(doctorId)

  //         }
  //       );
  //       if (matchedDoctor) {
  //         setSelectedDoctor(
  //           matchedDoctor
  //         );
  //       }
  //       console.log(matchedDoctor, "this is macthed doctor")

  //       // setSelectedDoctor(
  //       //   matchedDoctor || data.doctors[0]
  //       // );
  //     };
  //   }

  //   return () => {
  //     if (autoOpenRef) autoOpenRef.current = null;
  //   };
  // }, [autoOpenRef, data]);
useEffect(() => {
  if (autoOpenRef && providers?.length > 0) {
    autoOpenRef.current = (doctorId) => {
      const matchedDoctor = providers.find(
        (doc) => String(doc.providerId) === String(doctorId)
      );
      if (matchedDoctor) {
        setSelectedDoctor(matchedDoctor);
      }
    };
  }

  return () => {
    if (autoOpenRef) autoOpenRef.current = null;
  };
}, [autoOpenRef, providers]);
  if (!data) return null;
  const { id, heading, doctors } = data;

  const handleBarBook = ({ doctor: doctorName, doctorData }) => {
    if (doctorData) {
      setSelectedDoctor(doctorData);
    } else if (doctorName) {
      const matched = doctors.find((d) => d.name === doctorName);
      setSelectedDoctor(matched ?? doctors[0]);
    } else {
      setSelectedDoctor(doctors[0]);
    }
  };
  if (loading) {
    return (
      <div
        style={{
          minHeight: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "16px",
          fontWeight: 500,
        }}
      >
        Loading providers...
      </div>
    );
  }

  return (
    <>
      {/* <div className='mx-5 my-5'>
        <AppointmentBar onBook={handleBarBook} />
      </div> */}
      <section id={id} className="w-full "
      //  style={{ backgroundColor: '#f9fafb' }}
      >
        <div className="container mx-auto px-4 md:px-8">
          {/* <h2 className="ava-heading-lg mb-6 md:mb-8">
            {heading}
          </h2> */}

          <div className="grid grid-cols-1 gap-4">
            {/* {providers.slice(2,3).map((doc) => (
              <DoctorCard
                key={doc.providerId}
                doc={doc}
                onBook={() => setSelectedDoctor(doc)}
              />
            ))} */}
            {providers.filter((doc) => doc.providerId === "7beea562-4f70-475c-95fe-256e348a1f27").map((doc) => (
              <DoctorCard
                key={doc.providerId}
                doc={doc}
                onBook={() => setSelectedDoctor(doc)}
              />
            ))}
          </div>
        </div>
      </section>

      {selectedDoctor && (
        <AppointmentModal autoOpenRef={autoOpenRef} doctor={selectedDoctor} onClose={handleClose} />
      )}
    </>
  );
};
const formatAddress = (address) => {
  if (!address) return '';
  const { addressLine, city, state, pincode } = address;
  return [addressLine, city, state, pincode].filter(Boolean).join(', ');
};

const useNextAvailableSlot = (providerId) => {
  const [nextSlot, setNextSlot] = useState(null); // { dateTime, slotId, ... } | null
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!providerId) { setLoading(false); return; }
    let cancelled = false;

    const fetchNext = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://api.avexa.net/clinic-onboarding/providers/${providerId}/slots`
        );
        if (!res.ok) throw new Error('Failed to fetch slots');
        const data = await res.json();
        const now = new Date();

        const upcoming = (data ?? [])
          .filter((s) => s.status === 'AVAILABLE')
          .map((s) => {
            const [h, m] = s.startTime.split(':').map(Number);
            const dateTime = parseLocalDate(s.slotDate);
            dateTime.setHours(h, m, 0, 0);
            return { ...s, dateTime };
          })
          .filter((s) => s.dateTime > now)
          .sort((a, b) => a.dateTime - b.dateTime);

        if (!cancelled) setNextSlot(upcoming[0] ?? null);
      } catch {
        if (!cancelled) setNextSlot(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchNext();
    return () => { cancelled = true; };
  }, [providerId]);

  return { nextSlot, loading };
};
// ── formatter: "Today" / "Tomorrow" / "Jul 5" ──
const formatNextAvailableLabelDate = (dateTime) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const slotDay = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

  if (slotDay.getTime() === today.getTime()) return 'Today';
  if (slotDay.getTime() === tomorrow.getTime()) return 'Tomorrow';
  return `${MONTH_SHORT[dateTime.getMonth()]} ${dateTime.getDate()}`;
};
// ── formatter: "Today, 3:30 PM" / "Tomorrow, 9:00 AM" / "Jul 5, 11:00 AM" ──
const formatNextAvailableLabel = (dateTime) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const slotDay = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

  const timeLabel = formatSlotTime(
    `${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`
  );

  if (slotDay.getTime() === today.getTime()) return `Today, ${timeLabel}`;
  if (slotDay.getTime() === tomorrow.getTime()) return `Tomorrow, ${timeLabel}`;
  return `${MONTH_SHORT[dateTime.getMonth()]} ${dateTime.getDate()}, ${timeLabel}`;
};
const DoctorCard = ({ doc, onBook }) => {
  const {
    fullName, speciality, address, image,
    experienceYears, rating, providerType,
    availabilityNote, bio,
    specializations, consultationFee, languagesSpoken,
    consultationType, insurance, reviewCount, designation, providerId
  } = doc;
  const { nextSlot, loading: nextSlotLoading } = useNextAvailableSlot(providerId);

  const location = formatAddress(address);
  const directionsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
  const initials = fullName?.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();
  const isAvailable = providerType?.toLowerCase().includes("available") || providerType?.toLowerCase().includes("full");

  return (
    <div
      className="w-full rounded-3xl overflow-hidden bg-white flex flex-col md:flex-row"
      style={{ border: "0.5px solid #F4C0D1" }}
    >
      {/* ── Left: Doctor photo ONLY ────────────────────────── */}
      <div className="relative flex-shrink-0 w-full h-56 sm:h-72 md:h-auto md:w-[420px]">
        {image ? (
          <img
            src={image}
            alt={fullName}
            className="w-full h-full object-cover object-top"
            draggable={false}
          />
        ) : (
          <img
            src='/OurDoctors/Dr.Sruthi.svg'
            alt={fullName}
            className="w-full h-full object-cover object-top"
            draggable={false}
          />
        )}
      </div>

      {/* ── Right: everything else stacks here ─────────────── */}
      <div className="flex-1 min-w-0 flex flex-col">

        {/* Info block */}
        <div className="p-4 sm:p-6 flex flex-col gap-4">

          {/* Name + specialty + verified */}
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h3 className="ava-heading-md font-semibold mb-0.5"
                style={{ color: "black" }}
              >{fullName}</h3>
             
              <p
                className="inline-flex items-center ava-radius-md gap-1 text-sm font-semibold text-white"
                style={{
                  padding: "5px 10px",
                  backgroundColor: "var(--primary-color)", // Purple background
                  width: "fit-content",
                }}
              >
                <span>★</span>
                <span>{rating ?? 5}</span>
              </p>
            </div>
            <p className="text-sm mb-3" style={{ color: "#993556" }}>{speciality?.specialityName}</p>
            <span
              className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs"
              style={{ border: "1px solid #22c55e", color: "#166534", backgroundColor: "#f0fdf4" }}
            >
             
              <VerifiedIcon />
              Verified specialist
            </span>
          </div>

          {/* Location */}
          <div className="flex flex-col gap-1.5">
            <div className="flex items-start gap-2 text-sm" style={{ color: "var(--color-text-secondary)" }}>
              <PinIcon />
              <span>{location}</span>
            </div>
            <div className="flex items-center gap-2">
              <a
                href={directionsHref || "#"}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-1 text-xs"
                style={{ color: "#993556" }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="3 11 22 2 13 21 11 13 3 11" />
                </svg>
                Get directions
              </a>
            </div>
          </div>

          {/* Stats: Experience / Rating / Availability */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">

            {/* Experience */}
            <div className="flex items-center gap-2">
              <div className="flex-shrink-0 rounded-lg p-2" style={{ backgroundColor: "#FBEAF0" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                </svg>
              </div>
              <div>
                <p className="text-[11px]" style={{ color: "#993556" }}>Experience</p>
                <p className="text-sm font-medium" style={{ color: "#4B1528" }}>{experienceYears}</p>
              </div>
            </div>

           

            {/* Availability */}
            <div className="flex items-center gap-2">
              <div className="flex-shrink-0 rounded-lg p-2" style={{ backgroundColor: "#FBEAF0" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div>
                <p className="text-[11px]" style={{ color: "#993556" }}>Availability</p>
                <p className="text-sm font-medium" style={{ color: isAvailable ? "#0F6E56" : "#993C1D" }}>
                  {typeof providerType === "string" ? providerType.replace(/_/g, " ") : providerType}
                </p>
                {availabilityNote && (
                  <p className="text-[10px]" style={{ color: "#993556" }}>{availabilityNote}</p>
                )}
              </div>
            </div>
          </div>

          {/* About + Specializations */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-1">

            {/* About */}
            <div>
              <p className="text-xs font-medium mb-1.5 flex items-center gap-1.5" style={{ color: "#993556" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                About {fullName}
              </p>
              <p className="text-xs leading-relaxed" style={{ color: "var(--color-text-secondary)" }}>
                {bio ?? `Experienced ${designation}  dedicated to providing compassionate and personalized care to every patient.`}
              </p>
            </div>

            {/* Specializations */}
            <div>
              <p className="text-xs font-medium mb-1.5 flex items-center gap-1.5" style={{ color: "#993556" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                Specializations
              </p>
              <div className="flex flex-wrap gap-1.5">
               
                <span
                  // key={i}
                  className="text-[11px] px-2.5 py-1 rounded-full"
                  style={{ backgroundColor: "#FBEAF0", color: "#72243E", border: "0.5px solid #F4C0D1" }}
                >
                  {designation}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Info strip ───────────────────────────────────── */}
        <div
          className="grid grid-cols-2 sm:grid-cols-4 gap-y-3 gap-x-2 sm:divide-x px-4 sm:px-6 py-3"
          style={{ borderTop: "0.5px solid #F4C0D1", borderBottom: "0.5px solid #F4C0D1" }}
        >
          {[
            {
              icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              ),
              label: "Consultation Type",
              value: consultationType ?? "In-clinic",
            },
            {
              icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v4l3 3" />
                </svg>
              ),
              label: "Consultation Fee",
              value: consultationFee ? `₹${consultationFee} Onwards` : "₹999 Onwards",
            },
            {
              icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
              ),
              label: "Insurance",
              value: insurance ?? "Accepted",
            },
            {
              icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#993556" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              ),
              label: "Languages",
              value: Array.isArray(languagesSpoken) ? languagesSpoken.join(", ") : (languagesSpoken ?? "English"),
            },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 px-2 sm:px-4 first:pl-0 sm:last:pr-0">
              <span>{item.icon}</span>
              <div>
                <p className="text-[10px]" style={{ color: "#993556" }}>{item.label}</p>
                <p className="text-xs font-medium" style={{ color: "#4B1528" }}>{item.value}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ── Footer ───────────────────────────────────────── */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 sm:px-6 py-3">

          <span className="flex items-center gap-1.5 text-xs" style={{ color: "var(--color-text-tertiary)" }}>
            <CalendarIcon />
            Next available: <span style={{ color: "#993556" }}>
              {/* Today */}
              {nextSlotLoading
                ? 'Checking…'
                : nextSlot
                  ? formatNextAvailableLabelDate(nextSlot.dateTime)
                  : 'No upcoming slots'}
            </span>
          </span>

          <div className="flex items-center gap-2">
            <button
              onClick={onBook}
              // className="flex-1 sm:flex-initial flex items-center justify-center gap-2 text-sm font-medium text-white px-5 py-2.5 rounded-full whitespace-nowrap"
              // style={{ backgroundColor: "#D4537E", border: "none" }}
              className='btn-primary'
            >
              <CalendarIcon />
              Book appointment
            </button>
            
           
          </div>
        </div>
      </div>
    </div>
  );
};
/* ─── Success Modal ─── */
const SuccessModal = ({ doctor, date, slot, appointmentType, paymentStatus, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.45)' }} onClick={(e) => e.stopPropagation()}>
    <div className="bg-white rounded-2xl w-full flex flex-col items-center text-center p-8 relative" style={{ maxWidth: '420px' }} onClick={(e) => e.stopPropagation()}>
      <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg border hover:bg-gray-50 cursor-pointer" style={{ borderColor: 'var(--gray-200)', color: 'var(--primary-color)' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
      </button>
      <div className="flex items-center justify-center rounded-full mb-5" style={{ width: 72, height: 72, backgroundColor: 'var(--ava-color-success-100)', flexShrink: 0 }}>
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-success-base)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      </div>
      <h3 className="ava-heading-md mb-1 primary-g">Appointment Confirmed!</h3>
      <p className="ava-text-sm mb-5">Your appointment has been successfully booked.</p>
      <div className="w-full rounded-xl p-4 mb-6 text-left flex flex-col gap-3 ava-card-bg">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 rounded-lg overflow-hidden" style={{ width: 44, height: 44 }}>
            {doctor.image ? (
              <img src={doctor.image ? `${doctor.image}` : "/OurDoctors/Dr.Sruthi.svg"} alt={doctor.name} className="w-full h-full object-cover object-top" draggable={false} />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-pink-100 text-pink-700 font-semibold text-sm uppercase">
                {/* {doctor.name?.split(" ").map((n) => n[0]).join("").slice(0, 2)} */}
                <img src={doctor.image ? `${doctor.image}` : "/OurDoctors/Dr.Sruthi.svg"} alt={doctor.name} className="w-full h-full object-cover object-top" draggable={false} />
              </div>
            )}
          </div>
          <div>
            <p className="ava-text-sm">{doctor.name}</p>
            <p className="ava-text-xs">{doctor.role}</p>
          </div>
        </div>
        <div style={{ height: 1, backgroundColor: 'var(--gray-200)' }} />
        <div className="flex items-center gap-2">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="ava-text-sm">{date}</span>
        </div>
        <div className="flex items-center gap-2">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
          <span className="ava-text-sm">{slot}</span>
        </div>
        <div className="flex items-center gap-2">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            <circle cx="12" cy="9" r="2.5" />
          </svg><span className="ava-text-sm">{formatAddress(doctor.address)}</span>
        </div>
        {/* Appointment Type row */}
        <div className="flex items-center gap-2">
          {appointmentType === 'virtual' ? (
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="7" width="16" height="12" rx="2" />
              <polyline points="22 8 16 12 16 16 22 16 22 8" />
            </svg>
          ) : (
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
              <circle cx="12" cy="9" r="2.5" />
            </svg>
          )}
          <span className="ava-text-sm">
            {appointmentType === 'virtual' ? 'Virtual' : 'In-Person'}
          </span>
        </div>
        {/* Payment Status row */}
        <div className="flex items-center gap-2">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
          </svg>
          <span className="ava-text-sm" style={{ color: paymentStatus === 'paid' ? 'var(--ava-color-success-base)' : 'var(--ava-color-secondary-500)' }}>
            {paymentStatus === 'paid' ? 'Payment Completed' : 'Payment Pending'}
          </span>
        </div>
      </div>
      <button onClick={onClose} className="w-full py-3 rounded-xl font-semibold text-sm transition-opacity hover:opacity-90 cursor-pointer" style={{ backgroundColor: 'var(--primary-color)', color: '#fff', border: 'none' }}>Done</button>
    </div>
  </div>
);

/* ─────────────────────────────────────────────
   Constants
───────────────────────────────────────────── */
const SLOT_HOURS = [
  { h: 9, m: 0 }, { h: 9, m: 30 },
  { h: 10, m: 0 }, { h: 10, m: 30 },
  { h: 11, m: 0 }, { h: 11, m: 30 },
  { h: 12, m: 0 }, { h: 12, m: 30 },
  { h: 14, m: 0 }, { h: 14, m: 30 },
  { h: 15, m: 0 }, { h: 15, m: 30 },
  { h: 16, m: 0 }, { h: 16, m: 30 },
  { h: 17, m: 0 }, { h: 17, m: 30 },
];

const fmt12 = ({ h, m }) => {
  const ampm = h < 12 ? 'AM' : 'PM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  const mm = m === 0 ? '00' : '30';
  return `${hour12}:${mm} ${ampm}`;
};

const ALL_DAY_SLOTS = SLOT_HOURS.map(s => ({ ...s, label: fmt12(s) }));

const getAvailableSlots = (date) => {
  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  return ALL_DAY_SLOTS.map(s => {
    const slotTime = new Date(date);
    slotTime.setHours(s.h, s.m, 0, 0);
    const isPast = isToday && slotTime.getTime() <= now.getTime();
    return { label: s.label, disabled: isPast };
  });
};

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const OTP_LENGTH = 6;

const buildDateStrip = () => {
  const days = []; const today = new Date(); today.setHours(0, 0, 0, 0);
  for (let i = 0; i < 7; i++) { const d = new Date(today); d.setDate(today.getDate() + i); days.push(d); }
  return days;
};

/* ─── Shared modal header ─── */
const ModalHeader = ({ title, onClose }) => (
  <div className="flex items-center justify-between px-4 py-3 flex-shrink-0" style={{ borderBottom: '1px solid #f0f0f0' }}>
    <div className="w-8" />
    <h3 className="ava-text-subheading">{title}</h3>
    <button
      onClick={onClose}
      className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
      style={{ color: 'var(--text-light)', background: 'none', border: 'none' }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>
);

/* ─── Doctor mini card ─── */
const DoctorMiniCard = ({ doctor }) => (
  <div className="px-4 py-3 flex items-start gap-3" style={{ borderBottom: '1px solid #f0f0f0' }}>
    <div className="flex-shrink-0 rounded-xl overflow-hidden" style={{ width: 72, height: 72, backgroundColor: 'var(--light-blue, #dce8f5)' }}>
      {doctor.image ? (
        <img
          src={doctor.image}
          alt={doctor.name}
          className="w-full h-full object-cover object-top"
          draggable={false}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-pink-100 text-pink-700 font-semibold text-xl uppercase">
     
          <img src={doctor.image ? `${doctor.image}` : "/OurDoctors/Dr.Sruthi.svg"} alt={doctor.name} className="w-full h-full object-cover object-top" draggable={false} />
        </div>
      )}
    </div>
    <div className="flex-1 min-w-0 pt-0.5">
      <p className="ava-text-subheading">{doctor.fullName}</p>
      <p className="ava-text-caption mt-0.5">{doctor.speciality?.specialityName}</p>
      <div className="flex items-start gap-1.5 mt-1.5">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-info-base)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0 mt-0.5">
          <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
        <div>
          {/* <p className="ava-text-xs" style={{ color: 'var(--ava-color-info-base)' }}>{doctor.clinic || `Mukta Women's Clinic`}</p> */}
          <p className="ava-text-xs">{formatAddress(doctor.address) || doctor.location}</p>
          {doctor.distance && <p className="ava-text-xs mt-0.5">{doctor.distance}</p>}
        </div>
      </div>
    </div>
  </div>
);

// ── helper: convert "11:00" → "11:00 AM" ──
const formatSlotTime = (time24) => {
  const [h, m] = time24.split(':').map(Number);
  const ampm = h < 12 ? 'AM' : 'PM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${m.toString().padStart(2, '0')} ${ampm}`;
};

// ── helper: "2026-06-22" → Date object (local, no timezone shift) ──
const parseLocalDate = (dateStr) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
};



const Step1DateTime = ({ doctor, onClose, onNext }) => {
  const [appointmentType, setAppointmentType] = useState('inperson');
  const [selectedSlot, setSelectedSlot] = useState(null);   // full slot object from API
  const [showCalendar, setShowCalendar] = useState(false);
  const [allSlots, setAllSlots] = useState([]);             // raw API response
  const [slotsLoading, setSlotsLoading] = useState(true);
  const [slotsError, setSlotsError] = useState(null);

  const todayRef = new Date(); todayRef.setHours(0, 0, 0, 0);
  const [calYear, setCalYear] = useState(todayRef.getFullYear());
  const [calMonth, setCalMonth] = useState(todayRef.getMonth());
  const calendarBtnRef = useRef(null);
  const calendarPopRef = useRef(null);
  const [amount, setAmount] = useState("800");

  // ── fetch slots for this provider ──
  useEffect(() => {
    const fetchSlots = async () => {
      try {
        setSlotsLoading(true);
        const res = await fetch(
          `https://api.avexa.net/clinic-onboarding/providers/${doctor.providerId}/slots`
        );
        if (!res.ok) throw new Error('Failed to fetch slots');
        const data = await res.json();
        setAllSlots(data ?? []);
      } catch (err) {
        setSlotsError(err.message);
      } finally {
        setSlotsLoading(false);
      }
    };
    if (doctor?.providerId) fetchSlots();
  }, [doctor?.providerId,]);


  const availableDates = useMemo(() => {
    const dateSet = new Set(
      allSlots
        .filter(s => s.status === 'AVAILABLE')
        .map(s => s.slotDate)
    );
    return [...dateSet]
      .sort()
      .map(parseLocalDate)
      .filter(date => date >= todayRef);   // ← drop any date before today
  }, [allSlots, todayRef]);

  const [selectedDateIndex, setSelectedDateIndex] = useState(0);

  // reset selection when dates load
  useEffect(() => {
    setSelectedDateIndex(0);
    setSelectedSlot(null);
  }, [availableDates.length]);

  const selectedDay = availableDates[selectedDateIndex] ?? todayRef;

  
  const slotsForDay = useMemo(() => {
    const y = selectedDay.getFullYear();
    const m = String(selectedDay.getMonth() + 1).padStart(2, '0');
    const d = String(selectedDay.getDate()).padStart(2, '0');
    const localDateStr = `${y}-${m}-${d}`;

    const now = new Date();

    return allSlots
      .filter(s => s.slotDate === localDateStr)
      .map(s => {
        const [h, min] = s.startTime.split(':').map(Number);

        // build exact slot datetime using selected day's date + slot's time
        const slotDateTime = new Date(
          selectedDay.getFullYear(),
          selectedDay.getMonth(),
          selectedDay.getDate(),
          h, min, 0, 0
        );

        const isPast = slotDateTime <= now;              // ← past slots disabled
        const isOccupied = s.status !== 'AVAILABLE';    // ← booked slots disabled

        return {
          ...s,
          label: formatSlotTime(s.startTime),
          disabled: isPast || isOccupied,
        };
      })
      .sort((a, b) => a.startTime.localeCompare(b.startTime));
  }, [allSlots, selectedDay]);
  // calendar click-outside
  useEffect(() => {
    if (!showCalendar) return;
    const handler = (e) => {
      if (
        calendarBtnRef.current && !calendarBtnRef.current.contains(e.target) &&
        calendarPopRef.current && !calendarPopRef.current.contains(e.target)
      ) setShowCalendar(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showCalendar]);

  const formatFullDate = (date) =>
    `${DAY_NAMES[date.getDay()]}, ${date.getDate()} ${MONTH_NAMES[date.getMonth()]}`;

  // calendar grid
  const calDaysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
  const calFirstDay = new Date(calYear, calMonth, 1).getDay();
  const calCells = [];
  for (let i = 0; i < calFirstDay; i++) calCells.push(null);
  for (let d = 1; d <= calDaysInMonth; d++) calCells.push(d);

  const isDateAvailable = (day) => {
    if (!day) return false;
    const y = calYear, m = String(calMonth + 1).padStart(2, '0'), d = String(day).padStart(2, '0');
    const dateStr = `${y}-${m}-${d}`;
    return allSlots.some(s => s.slotDate === dateStr && s.status === 'AVAILABLE');
  };

  const isPastCalDay = (day) => !day || new Date(calYear, calMonth, day) < todayRef;

  const handleCalDayPick = (day) => {
    if (!day || isPastCalDay(day) || !isDateAvailable(day)) return;
    const picked = new Date(calYear, calMonth, day);
    const idx = availableDates.findIndex(d =>
      d.getFullYear() === picked.getFullYear() &&
      d.getMonth() === picked.getMonth() &&
      d.getDate() === picked.getDate()
    );
    if (idx !== -1) setSelectedDateIndex(idx);
    setSelectedSlot(null);
    setShowCalendar(false);
  };

  const calPrevMonth = () => {
    if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); }
    else setCalMonth(m => m - 1);
  };
  const calNextMonth = () => {
    if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); }
    else setCalMonth(m => m + 1);
  };
  const isCalMonthBlocked = calYear === todayRef.getFullYear() && calMonth <= todayRef.getMonth();

  const handleConfirm = () => {
    if (!selectedSlot) { alert('Please select a time slot'); return; }
    console.log(MONTH_NAMES[selectedDay.getMonth()], "this s the selected date, month");
    console.log(selectedSlot.label, "selectedSlot.label");
    console.log(selectedSlot.slotDate, "selectedSlot.slotDate");
    console.log(appointmentType, "appointmentType")
    // return;
    onNext({
      date: `${MONTH_NAMES[selectedDay.getMonth()]} ${selectedDay.getDate()}, ${selectedDay.getFullYear()}`,
      slot: selectedSlot.label,
      slotId: selectedSlot.slotId,       // pass to booking API later
      slotDate: selectedSlot.slotDate,
      appointmentType,
    });
  };

  // strip: show up to 4 available dates
  const stripDates = availableDates.slice(0, 4);

  return (
    <>
      <ModalHeader title="Schedule Appointment" onClose={onClose} />
      <div className="overflow-y-auto flex-1">
        <DoctorMiniCard doctor={doctor} />

        {/* Appointment Type */}
        <div className="px-4 pt-4 pb-2">
          <p className="ava-text-subheading mb-3">Appointment Type</p>
          <div className="flex gap-3">
            {[
              {
                id: 'inperson', label: 'In-Person',
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" /><circle cx="12" cy="9" r="2.5" /></svg>,
              },
              {
                id: 'virtual', label: 'Virtual',
                icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="16" height="12" rx="2" /><polyline points="22 8 16 12 16 16 22 16 22 8" /></svg>,
              },
            ].map((type) => {
              const isSelected = appointmentType === type.id;
              return (
                <button key={type.id} onClick={() => setAppointmentType(type.id)}
                  className="flex-1 flex flex-row items-center justify-center gap-2 py-4 rounded-2xl transition-all cursor-pointer"
                  style={{
                    border: isSelected ? '2px solid var(--primary-color, #00246B)' : '1.5px solid #e5e7eb',
                    backgroundColor: isSelected ? 'var(--ava-bg-primary-light)' : '#ffffff',
                    color: isSelected ? 'var(--primary-color, #00246B)' : '#9ca3af',
                  }}>
                  {type.icon}
                  <span className="text-sm" style={{ fontWeight: isSelected ? '700' : '400', color: isSelected ? 'var(--primary-color, #00246B)' : '#9ca3af' }}>
                    {type.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Date strip */}
        <div className="px-4 pt-4 pb-3">
          <p className="ava-text-subheading mb-3">Select Date &amp; Time</p>

          {slotsLoading ? (
            <p className="ava-text-xs text-center py-4" style={{ color: '#9ca3af' }}>Loading available slots…</p>
          ) : slotsError ? (
            <p className="ava-text-xs text-center py-4" style={{ color: 'var(--ava-color-error-base)' }}>{slotsError}</p>
          ) : availableDates.length === 0 ? (
            <p className="ava-text-xs text-center py-4" style={{ color: '#9ca3af' }}>No available slots this week.</p>
          ) : (
            <>
              <div className="flex items-center gap-2">
                <div className="flex gap-2 flex-1">
                  {stripDates.map((date, i) => {
                    const isSelected = selectedDateIndex === i;
                    const isActualToday =
                      date.getFullYear() === todayRef.getFullYear() &&
                      date.getMonth() === todayRef.getMonth() &&
                      date.getDate() === todayRef.getDate();
                    return (
                      <button key={i}
                        onClick={() => { setSelectedDateIndex(i); setSelectedSlot(null); }}
                        className="flex flex-col items-center flex-1 py-2 rounded-2xl ava-text-xs transition-all"
                        style={{
                          backgroundColor: isSelected ? 'var(--secondary-color)' : '#f3f4f6',
                          color: isSelected ? '#fff' : '#374151',
                          border: 'none', cursor: 'pointer',
                        }}>
                        <span className="text-xs leading-tight" style={{ opacity: isSelected ? 0.85 : 0.6 }}>
                          {isActualToday ? 'Today' : DAY_NAMES[date.getDay()]}
                        </span>
                        <span className="font-bold text-sm leading-tight">{date.getDate()}</span>
                        <span className="text-xs leading-tight" style={{ opacity: isSelected ? 0.85 : 0.6 }}>
                          {MONTH_SHORT[date.getMonth()]}
                        </span>
                      </button>
                    );
                  })}
                </div>

                {/* Calendar picker */}
                <button ref={calendarBtnRef} onClick={() => setShowCalendar(v => !v)}
                  className="flex-shrink-0 flex flex-col items-center justify-center rounded-2xl py-2 px-3 transition-colors cursor-pointer"
                  style={{ backgroundColor: showCalendar ? 'var(--secondary-color)' : '#f3f4f6', border: 'none', minWidth: 44, minHeight: 56 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={showCalendar ? '#fff' : '#374151'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </button>
              </div>

              {showCalendar && (
                <div ref={calendarPopRef} className="fixed z-[60] bg-white rounded-2xl shadow-2xl p-4"
                  style={{ width: 300, border: '1px solid #e5e7eb', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                  <div className="flex items-center justify-between mb-4">
                    <button onClick={calPrevMonth} disabled={isCalMonthBlocked}
                      className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer"
                      style={{ border: 'none', background: 'none', opacity: isCalMonthBlocked ? 0.3 : 1 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6" /></svg>
                    </button>
                    <span className="font-semibold text-sm" style={{ color: '#1a1a1a' }}>{MONTH_NAMES[calMonth]} {calYear}</span>
                    <button onClick={calNextMonth} className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer" style={{ border: 'none', background: 'none' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2.5" strokeLinecap="round"><polyline points="9 18 15 12 9 6" /></svg>
                    </button>
                  </div>
                  <div className="grid grid-cols-7 mb-1">
                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
                      <div key={d} className="text-center text-xs font-semibold py-1" style={{ color: '#9ca3af' }}>{d}</div>
                    ))}
                  </div>
                  <div className="grid grid-cols-7 gap-y-1">
                    {calCells.map((day, idx) => {
                      const past = isPastCalDay(day);
                      const hasSlots = isDateAvailable(day);
                      const isDisabled = !day || past || !hasSlots;
                      return (
                        <button key={idx} onClick={() => handleCalDayPick(day)} disabled={isDisabled}
                          className="flex items-center justify-center text-sm py-1.5 rounded-lg transition-colors relative"
                          style={{
                            border: 'none',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            backgroundColor: 'transparent',
                            color: isDisabled ? '#d1d5db' : '#1a1a1a',
                            opacity: isDisabled ? 0.4 : 1,
                          }}>
                          {day || ''}
                          {/* green dot for available dates */}
                          {hasSlots && !past && day && (
                            <span style={{
                              position: 'absolute', bottom: 2, left: '50%',
                              transform: 'translateX(-50%)',
                              width: 4, height: 4, borderRadius: '50%',
                              backgroundColor: '#0F6E56',
                            }} />
                          )}
                        </button>
                      );
                    })}
                  </div>
                  <p className="text-xs text-center mt-3" style={{ color: '#9ca3af' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#0F6E56', display: 'inline-block' }} />
                      Available dates
                    </span>
                  </p>
                </div>
              )}
            </>
          )}
        </div>

        {/* Time slots for selected day */}
        {!slotsLoading && availableDates.length > 0 && (
          <div className="mx-4 mb-4 rounded-xl p-4" style={{ backgroundColor: '#f8faff', border: '1px solid #e8eeff' }}>
            <p className="ava-text-subheading mb-1">Available Time Slots</p>
            <p className="ava-text-caption mb-3">{formatFullDate(selectedDay)}</p>
            {slotsForDay.length === 0 ? (
              <p className="ava-text-xs" style={{ color: '#9ca3af' }}>No slots available for this day.</p>
            ) : (
              <div className="grid grid-cols-4 gap-1.5">
                {slotsForDay.map((slot) => {
                  const isSelected = selectedSlot?.slotId === slot.slotId;
                  return (
                    <button key={slot.slotId}
                      onClick={() => !slot.disabled && setSelectedSlot(slot)}
                      disabled={slot.disabled}
                      className="py-1.5 rounded-lg text-xs font-medium transition-all"
                      style={{
                        backgroundColor: slot.disabled ? '#f3f4f6' : isSelected ? 'var(--secondary-color)' : '#fff',
                        color: slot.disabled ? '#d1d5db' : isSelected ? '#fff' : '#374151',
                        border: slot.disabled ? '1.5px solid #e5e7eb' : isSelected ? '1.5px solid var(--secondary-color)' : '1.5px solid #e5e7eb',
                        cursor: slot.disabled ? 'not-allowed' : 'pointer',
                        textDecoration: slot.disabled ? 'line-through' : 'none',
                      }}>
                      {slot.label}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="px-4 pt-3 pb-4 flex-shrink-0" style={{ borderTop: '1px solid #f0f0f0' }}>
        <button onClick={handleConfirm}
          className="w-full py-3 rounded-xl ava-text-sm transition-opacity hover:opacity-90 cursor-pointer"
          style={{ backgroundColor: 'var(--primary-color, #185FA5)', color: '#fff', border: 'none' }}>
          Confirm Appointment
        </button>
        <div className="flex items-center justify-center gap-2 mt-3 flex-wrap">
          {['Health Information', 'Emergency Contacts', 'Disclaimers'].map((link, i, arr) => (
            <span key={link} className="flex items-center gap-2">
              <a href="#" className="ava-text-xs hover:underline">{link}</a>
              {i < arr.length - 1 && <span className="ava-text-xs" style={{ color: '#d1d5db' }}>|</span>}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};
/* ═══════════════════════════════════════════
   STEP 2 — Patient details + Send OTP
═══════════════════════════════════════════ */
const Step2PatientDetails = ({ doctor, booking, onBack, onClose, onNext, notify }) => {
  const [fullName, setFullName] = useState('');
  const [mobile, setMobile] = useState('');
  const [dob, setDob] = useState('');
  const [nameErr, setNameErr] = useState('');
  const [mobErr, setMobErr] = useState('');
  const [dobErr, setDobErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [apiErr, setApiErr] = useState('');

  const {
    user
  } = useAuth();

  // CHECK VERIFIED

  const isVerified =
    isMobileVerified(
      mobile || user?.mobile || '',
    );

  // console.log("pppppp", user, isVerified);

  const handleSendOtp = async () => {
    // console.log('Verifying details before sending OTP...', { fullName, mobile, dob });
    let ok = true;
    if (!fullName.trim()) { setNameErr('Full name is required'); ok = false; } else setNameErr('');
    if (!/^\d{10}$/.test(mobile.trim())) { setMobErr('Enter a valid 10-digit mobile number'); ok = false; } else setMobErr('');
    // if (!dob) { setDobErr('Date of birth is required'); ok = false; } else setDobErr('');
    if (!ok) return;
    // console.log('Details valid. Proceeding with OTP logic...', { fullName, mobile, dob, isVerified });

    // Verified user — skip OTP entirely
    if (isVerified) {
      onNext({ fullName: fullName.trim(), mobile: mobile.trim(), skipOtp: true });
      return;
    }

    // New user — call sendQuickOtp API
    setLoading(true);
    setApiErr('');
    try {
      // await quickRegister({ fullName: fullName.trim(), mobileNumber: mobile.trim(), orgName:"Mukta Women's Clinic", dob: dob.trim() });
      const res = await sendQuickOtp({
        fullName: fullName.trim(),
        mobileNumber: mobile.trim(),
      });
      if (res.success) {
        notify('success', 'OTP sent successfully! Please verify to confirm your appointment.');
        onNext({ fullName: fullName.trim(), mobile: mobile.trim(), skipOtp: false });
      } else {
        console.error('OTP API error:', res);
        notify('error', res?.message || 'Failed to send OTP. Please try again.');
      }

    } catch (err) {
      console.log("err", err)
      setApiErr(err?.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedName = localStorage.getItem('userName');
    if (storedName) {
      setFullName(storedName);
    }
  }, []);

  useEffect(() => {
    if (user?.fullName) setFullName(user.fullName);
    if (user?.mobile) setMobile(user.mobile);
    if (user?.dob) setDob(user.dob);
  }, [user]);

  return (
    <>
      <ModalHeader title="Schedule Appointment" onClose={onClose} />


      <div className="overflow-y-auto flex-1">
        <DoctorMiniCard doctor={doctor} />

        {/* Booking summary pill */}
        <div className="mx-4 mt-3 px-3 py-2 rounded-xl flex items-center gap-2" style={{ backgroundColor: 'var(--ava-color-secondary-50)', border: '1px solid #fdd8be' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="text-xs font-semibold" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.date}</span>
          <span className="text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>·</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
          <span className="ava-text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.slot}</span>
        </div>

        {/* Form */}
        <div className="px-4 pt-4 pb-2 flex flex-col gap-4">
          <p className="ava-text-subheading">Your Details</p>

          {/* Full Name */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Full Name</label>
            <input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={e => { setFullName(e.target.value); setNameErr(''); }}
              className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors"
              style={{ border: nameErr ? '1.5px solid var(--ava-color-error-base)' : '1.5px solid #e5e7eb', backgroundColor: '#fff' }}
            />
            {nameErr && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base)' }}>{nameErr}</p>}
          </div>
         
          {/* Mobile with dial code */}
          <div className="flex flex-col gap-1">
            <label className="ava-text-xs" style={{ color: '#374151' }}>Mobile Number</label>
            <div className="flex rounded-xl overflow-hidden" style={{ border: mobErr ? '1.5px solid var(--ava-color-error-base)' : '1.5px solid #e5e7eb' }}>
              <div className="flex items-center px-3 py-3 flex-shrink-0" style={{ backgroundColor: '#f3f4f6', borderRight: '1.5px solid #e5e7eb' }}>
                <span className="ava-text-sm" style={{ color: '#374151' }}>+91</span>
              </div>
              <input
                type="tel"
                placeholder="Enter 10-digit mobile number"
                value={mobile}
                maxLength={10}
                disabled={isVerified}
                onChange={e => { if (!isVerified) { setMobile(e.target.value.replace(/\D/g, '')); setMobErr(''); } }}
                className="flex-1 min-w-0 px-3 py-3 text-sm outline-none bg-white"
                style={{ border: 'none', backgroundColor: isVerified ? '#f3f4f6' : '#fff', color: isVerified ? '#6b7280' : 'inherit', cursor: isVerified ? 'not-allowed' : 'text' }}
              />
            </div>
            {mobErr && <p className="ava-text-xs" style={{ color: 'var(--ava-color-error-base)' }}>{mobErr}</p>}
            <p className="ava-text-caption mt-0.5">
              {isVerified
                ? 'Your mobile number is already verified.'
                : 'An OTP will be sent to this number for verification.'}
            </p>
            {apiErr && <p className="ava-text-xs mt-1" style={{ color: 'var(--ava-color-error-base)' }}>{apiErr}</p>}
          </div>
        </div>
      </div>

      <div className="px-4 pt-3 pb-4 flex-shrink-0" style={{ borderTop: '1px solid #f0f0f0' }}>
        <button onClick={handleSendOtp} className="w-full py-3 rounded-xl font-semibold text-sm transition-opacity hover:opacity-90 cursor-pointer" style={{ backgroundColor: loading ? '#9ca3af' : 'var(--primary-color)', color: '#fff', border: 'none', cursor: loading ? 'wait' : 'pointer' }}>
          {loading ? 'Sending OTP…' : isVerified ? 'Continue' : 'Send OTP'}
        </button>
      </div>
    </>
  );
};


/* ═══════════════════════════════════════════
   STEP 3 — OTP verification
═══════════════════════════════════════════ */
const Step3OTP = ({ doctor, booking, patient, onBack, onClose, onVerified }) => {
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
  const [error, setError] = useState('');
  const [resent, setResent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...otp]; next[i] = val;
    setOtp(next); setError('');
    if (val && i < OTP_LENGTH - 1) inputRefs.current[i + 1]?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) inputRefs.current[i - 1]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH).split('');
    const next = [...otp];
    pasted.forEach((d, i) => { if (i < OTP_LENGTH) next[i] = d; });
    setOtp(next);
    inputRefs.current[Math.min(pasted.length, OTP_LENGTH - 1)]?.focus();
  };

  const handleVerify = async () => {
    const code = otp.join("");

    if (
      code.length < OTP_LENGTH
    ) {
      setError(
        `Please enter all ${OTP_LENGTH} digits`
      );

      return;
    }

    setLoading(true);

    try {
      // ==========================================
      // VERIFY OTP
      // ==========================================

      await verifyOtp({
        fullName:
          patient.fullName,

        mobileNumber:
          patient.mobile,

        otp: code,
      });

      // ==========================================
      // REGISTER USER
      // ==========================================

      const registerResponse =
        await quickRegister({
          fullName:
            patient.fullName,

          mobileNumber:
            patient.mobile,

          dob: patient.dob,
          otp: code,

          orgName:
            "Mukta Women's Clinic",
        });

      // ==========================================
      // STORE USER
      // ==========================================

      storePatientSession(
        { ...registerResponse.data, fullName: patient.fullName, mobile: patient.mobile, dob: patient.dob, isVerified: true },
      );

      setLoading(false);

      onVerified();
    } catch (err) {
      setLoading(false);

      setError(
        err?.message ||
        "Invalid OTP. Please try again."
      );
    }
  };

  const handleResend = async () => {
    if (countdown > 0) return;
    setOtp(Array(OTP_LENGTH).fill(''));
    setError('');
    setResent(false);
    setCountdown(60);
    try {
      await sendQuickOtp({ fullName: patient.fullName, mobile: patient.mobile });
      setResent(true);
      setTimeout(() => setResent(false), 3000);
    } catch (err) {
      setError(err?.message || 'Failed to resend OTP. Please try again.');
    }
  };


  return (
    <>
      <ModalHeader title="Verify OTP" onClose={onClose} />

      <div className="overflow-y-auto flex-1">
        <DoctorMiniCard doctor={doctor} />

        {/* Booking summary */}
        <div className="mx-4 mt-3 px-3 py-2 rounded-xl flex items-center gap-2" style={{ backgroundColor: 'var(--ava-color-secondary-50)', border: '1px solid var(--ava-color-secondary-500)' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="ava-text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.date}</span>
          <span className="ava-text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>·</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
          <span className="ava-text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.slot}</span>
        </div>

        <div className="px-4 pt-5 pb-2 flex flex-col items-center gap-4">
          <div className="text-center">
            <p className="ava-text-sm">Enter Verification Code</p>
            <p className="ava-text-xs mt-1">
              We sent a {OTP_LENGTH}-digit OTP to <strong>+91 {patient.mobile}</strong>
            </p>
          </div>

          {/* OTP boxes */}
          <div className="flex flex-wrap gap-2 justify-center" onPaste={handlePaste}>
            {otp.map((digit, i) => (
              <input
                key={i}
                ref={el => inputRefs.current[i] = el}
                type="tel"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={e => handleChange(i, e.target.value)}
                onKeyDown={e => handleKeyDown(i, e)}
                className="text-center font-bold text-lg rounded-xl outline-none transition-all"
                style={{
                  width: 44, height: 52,
                  border: digit ? '2px solid var(--ava-color-secondary-500)' : error ? '2px solid var(--ava-color-error-base)' : '2px solid #e5e7eb',
                  backgroundColor: digit ? 'var(--ava-color-secondary-50)' : '#fff',
                  color: '#1a1a1a',
                }}
              />
            ))}
          </div>

          {error && <p className="ava-text-xs text-center" style={{ color: 'var(--ava-color-error-base)' }}>{error}</p>}
          {resent && <p className="ava-text-xs text-center" style={{ color: '#22c55e' }}>OTP resent successfully!</p>}

          {/* Resend */}
          <p className="ava-text-xs" style={{ color: 'var(--text-light)' }}>
            Didn't receive it?{' '}
            {countdown > 0 ? (
              <span style={{ color: '#9ca3af' }}>
                Resend in <strong style={{ color: 'var(--primary-color)' }}>{countdown}s</strong>
              </span>
            ) : (
              <button onClick={handleResend} className="cursor-pointer" style={{ color: 'var(--primary-color)', background: 'none', border: 'none' }}>
                Resend OTP
              </button>
            )}
          </p>
        </div>
      </div>

      <div className="px-4 pt-3 pb-4 flex-shrink-0" style={{ borderTop: '1px solid #f0f0f0' }}>
        <button onClick={handleVerify} disabled={loading}
          className="w-full py-3 rounded-xl ava-text-sm transition-opacity hover:opacity-90 cursor-pointer"
          style={{ backgroundColor: loading ? '#9ca3af' : 'var(--primary-color)', color: '#fff', border: 'none', cursor: loading ? 'wait' : 'pointer' }}
        >
          {loading ? 'Verifying…' : 'Confirm & Continue'}
        </button>
      </div>
    </>
  );
};

/* ═══════════════════════════════════════════
   STEP 4 — Payment Selection
═══════════════════════════════════════════ */
const PAYMENT_METHODS = [
  {
    id: 'upi',
    label: 'UPI',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  {
    id: 'card',
    label: 'Credit / Debit Card',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
  {
    id: 'netbanking',
    label: 'Net Banking',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
];

const Step4Payment = ({ doctor, booking, onClose, onDone }) => {
  const [paymentChoice, setPaymentChoice] = useState('pay_now'); // 'pay_now' | 'pay_later'
  const [selectedMethod, setSelectedMethod] = useState('upi');
  const [loading, setLoading] = useState(false);
  const [apiErr, setApiErr] = useState('');
 
  const handlePay = async () => {
    setLoading(true);
    setApiErr('');
    // const patientId=`6a23a69ebff70111a9380b6c`;
    const raw = JSON.parse(localStorage.getItem('patientPersona'));
    const patientId = raw.patientId;
    try {
      const res = await fetch(`${API_BASE_URL}/book-an-appointment/appointment/book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          clinicId: '6a352e39ab22c07f82b4261a',
          providerId: doctor.providerId,
          patientId: patientId,  // use actual patientId once you have it
          slotId: booking.slotId,
          appointmentDate: booking.slotDate,                    // "2026-06-22"
          appointmentType: booking.appointmentType === 'virtual'
            ? 'VIRTUAL'
            : 'IN_PERSON',
          paymentOption: paymentChoice === 'pay_now' ? 'PAY_NOW' : 'PAY_LATER',
          amount: '800'
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err?.message || 'Booking failed');
      }

      onDone({ paymentStatus: paymentChoice === 'pay_now' ? 'paid' : 'pending' });
    } catch (err) {
      setApiErr(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const isPayNow = paymentChoice === 'pay_now';

  return (
    <>
      <ModalHeader title="Payment" onClose={onClose} />

      <div className="overflow-y-auto flex-1">
        <DoctorMiniCard doctor={doctor} />

        {/* Booking summary pill */}
        <div className="mx-4 mt-3 px-3 py-2 rounded-xl flex items-center gap-2" style={{ backgroundColor: 'var(--ava-color-secondary-50)', border: '1px solid #fdd8be' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span className="text-xs font-semibold" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.date}</span>
          <span className="text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>·</span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-secondary-500)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
          <span className="ava-text-xs" style={{ color: 'var(--ava-color-secondary-500)' }}>{booking.slot}</span>
        </div>

        <div className="px-4 pt-4 pb-2 flex flex-col gap-4">

          {/* Payment Choice Cards */}
          <div>
            <p className="ava-text-subheading mb-3">Payment Option</p>
            <div className="flex gap-3">
              {[
                {
                  id: 'pay_now',
                  label: 'Pay Now',
                  sub: 'Secure online payment',
                  icon: (
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
                    </svg>
                  ),
                },
                {
                  id: 'pay_later',
                  label: 'Pay Later',
                  sub: 'Pay at the clinic',
                  icon: (
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                    </svg>
                  ),
                },
              ].map((choice) => {
                const isSelected = paymentChoice === choice.id;
                return (
                  <button
                    key={choice.id}
                    onClick={() => setPaymentChoice(choice.id)}
                    className="flex-1 flex flex-col items-center justify-center gap-1.5 py-4 px-3 rounded-2xl transition-all cursor-pointer"
                    style={{
                      border: isSelected
                        ? '2px solid var(--primary-color, #00246B)'
                        : '1.5px solid #e5e7eb',
                      backgroundColor: isSelected ? 'var(--ava-bg-primary-light)' : '#ffffff',
                    }}
                  >
                    <span style={{ color: isSelected ? 'var(--primary-color, #00246B)' : '#9ca3af' }}>
                      {choice.icon}
                    </span>
                    <span
                      className="text-sm"
                      style={{
                        fontWeight: isSelected ? '700' : '500',
                        color: isSelected ? 'var(--primary-color, #00246B)' : '#374151',
                      }}
                    >
                      {choice.label}
                    </span>
                    <span className="text-xs" style={{ color: isSelected ? 'var(--primary-color, #00246B)' : '#9ca3af', opacity: 0.8 }}>
                      {choice.sub}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Payment Summary — visible only for Pay Now */}
          {isPayNow && (
            <div className="rounded-xl p-4" style={{ backgroundColor: '#f8faff', border: '1px solid #e8eeff' }}>
              <p className="ava-text-subheading mb-3">Payment Summary</p>
              <div className="flex items-center justify-between mb-2">
                <span className="ava-text-sm">Consultation fee</span>
                <span className="ava-text-sm">₹800</span>
              </div>
              <div className="flex items-center justify-between mb-2">
                <span className="ava-text-sm">Platform fee</span>
                <span className="ava-text-sm">₹0</span>
              </div>
              <div style={{ height: 1, backgroundColor: '#e5e7eb', margin: '8px 0' }} />
              <div className="flex items-center justify-between">
                <span className="ava-text-subheading">Total amount</span>
                <span className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>₹800</span>
              </div>
            </div>
          )}

       
          {/* Payment Methods — visible only for Pay Now */}
          {isPayNow && (
            <div>
              <p className="ava-text-subheading mb-3">Choose Payment Method</p>

              <div className="flex flex-col gap-3">

                {PAYMENT_METHODS.map((method) => {
                  const isSelected = selectedMethod === method.id;

                  return (
                    <div
                      key={method.id}
                      onClick={() => setSelectedMethod(method.id)}
                      className="rounded-2xl cursor-pointer transition-all"
                      style={{
                        border: isSelected
                          ? '2px solid var(--primary-color, #00246B)'
                          : '1.5px solid #e5e7eb',
                        backgroundColor: isSelected ? '#f8f7ff' : '#fff',
                        overflow: 'hidden',
                      }}
                    >

                      {/* Top Row */}
                      <div
                        className="flex items-center justify-between px-4 py-4"
                      >
                        <div className="flex items-center gap-3">

                          {/* Radio */}
                          <div
                            className="flex items-center justify-center rounded-full"
                            style={{
                              width: 18,
                              height: 18,
                              border: isSelected
                                ? '2px solid var(--primary-color, #00246B)'
                                : '2px solid #d1d5db',
                            }}
                          >
                            {isSelected && (
                              <div
                                className="rounded-full"
                                style={{
                                  width: 8,
                                  height: 8,
                                  backgroundColor: 'var(--primary-color, #00246B)',
                                }}
                              />
                            )}
                          </div>

                          {/* Label */}
                          <span
                            className="ava-text-sm"
                            style={{
                              fontWeight: isSelected ? '600' : '500',
                              color: isSelected
                                ? 'var(--primary-color, #00246B)'
                                : '#374151',
                            }}
                          >
                            {method.label}
                          </span>
                        </div>

                        {/* Right Icons */}
                        <div className="flex items-center gap-2">

                          {method.id === 'upi' && (
                            <>
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: 'var(--ava-bg-primary-light)',
                                }}
                              />
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: '#fce7f3',
                                }}
                              />
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: '#ecfeff',
                                }}
                              />
                            </>
                          )}

                          {method.id === 'card' && (
                            <>
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: '#dbeafe',
                                }}
                              />
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: '#fee2e2',
                                }}
                              />
                              <div
                                className="rounded-md"
                                style={{
                                  width: 30,
                                  height: 20,
                                  backgroundColor: '#fef3c7',
                                }}
                              />
                            </>
                          )}

                        </div>
                      </div>

                      {/* Expanded Content */}
                      {isSelected && method.id === 'upi' && (
                        <div
                          className="px-4 pb-4 pt-1"
                          style={{
                            borderTop: '1px solid var(--ava-bg-primary-light)',
                          }}
                        >
                          <div className="grid grid-cols-2 gap-2 mt-3">

                            {['Google Pay', 'PhonePe', 'Paytm', 'BHIM'].map((app) => (
                              <button
                                key={app}
                                className="flex items-center justify-center py-3 rounded-xl text-sm font-medium transition-all"
                                style={{
                                  border: '1px solid #e5e7eb',
                                  backgroundColor: '#fff',
                                  color: '#374151',
                                }}
                              >
                                {app}
                              </button>
                            ))}

                          </div>
                        </div>
                      )}

                      {isSelected && method.id === 'card' && (
                        <div
                          className="px-4 pb-4 pt-1"
                          style={{
                            borderTop: '1px solid var(--ava-bg-primary-light)',
                          }}
                        >
                          <div className="flex flex-col gap-3 mt-3">

                            <input
                              type="text"
                              placeholder="Card Number"
                              className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                              style={{
                                border: '1.5px solid #e5e7eb',
                              }}
                            />

                            <div className="grid grid-cols-2 gap-3">
                              <input
                                type="text"
                                placeholder="MM/YY"
                                className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                                style={{
                                  border: '1.5px solid #e5e7eb',
                                }}
                              />

                              <input
                                type="password"
                                placeholder="CVV"
                                className="w-full px-4 py-3 rounded-xl text-sm outline-none"
                                style={{
                                  border: '1.5px solid #e5e7eb',
                                }}
                              />
                            </div>

                          </div>
                        </div>
                      )}

                      {isSelected && method.id === 'netbanking' && (
                        <div
                          className="px-4 pb-4 pt-1"
                          style={{
                            borderTop: '1px solid var(--ava-bg-primary-light)',
                          }}
                        >
                          <div className="grid grid-cols-2 gap-2 mt-3">

                            {[
                              'HDFC Bank',
                              'ICICI Bank',
                              'SBI',
                              'Axis Bank',
                            ].map((bank) => (
                              <button
                                key={bank}
                                className="py-3 rounded-xl text-sm font-medium"
                                style={{
                                  border: '1px solid #e5e7eb',
                                  backgroundColor: '#fff',
                                  color: '#374151',
                                }}
                              >
                                {bank}
                              </button>
                            ))}

                          </div>
                        </div>
                      )}

                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Pay Later note */}
          {!isPayNow && (
            <div className="rounded-xl p-4 flex items-start gap-3" style={{ backgroundColor: '#f8faff', border: '1px solid #e8eeff' }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--ava-color-info-base, #185FA5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0 mt-0.5">
                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <p className="ava-text-xs" style={{ color: '#374151' }}>
                Your appointment will be confirmed. You can pay the consultation fee of <strong>₹800</strong> directly at the clinic on the day of your visit.
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="px-4 pt-3 pb-4 flex-shrink-0" style={{ borderTop: '1px solid #f0f0f0' }}>
        <button
          onClick={handlePay}
          disabled={loading}
          className="w-full py-3 rounded-xl font-semibold text-sm transition-opacity hover:opacity-90 cursor-pointer"
          style={{
            backgroundColor: loading ? '#9ca3af' : 'var(--primary-color)',
            color: '#fff',
            border: 'none',
            cursor: loading ? 'wait' : 'pointer',
          }}
        >
          {loading
            ? (isPayNow ? 'Processing Payment…' : 'Confirming…')
            : (isPayNow ? `Pay ₹800 Securely` : 'Confirm Booking')
          }
        </button>
      </div>
    </>
  );
};

/* ═══════════════════════════════════════════
   MAIN Appointment Modal — orchestrates steps
═══════════════════════════════════════════ */
const AppointmentModal = ({ doctor, onClose }) => {
  const [step, setStep] = useState(1);  // 1 | 2 | 3 | 4
  const [booking, setBooking] = useState(null); // { date, slot, appointmentType }
  const [patient, setPatient] = useState(null); // { fullName, mobile }
  const [paymentStatus, setPaymentStatus] = useState(null); // 'paid' | 'pending'
  const [done, setDone] = useState(false);
  const [notif, setNotif] = useState(null);
  const notify = useCallback((type, message) => setNotif({ type, message }), []);
  const { user } = useAuth();

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  if (done) {
    return (
      <SuccessModal
        doctor={doctor}
        date={booking.date}
        slot={booking.slot}
        appointmentType={booking.appointmentType}
        paymentStatus={paymentStatus}
        onClose={onClose}
      />
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-4" style={{ backgroundColor: 'rgba(0,0,0,0.45)' }} onClick={(e) => e.stopPropagation()}>
      {notif && (
        <Notification
          type={notif.type}
          message={notif.message}
          onClose={() => setNotif(null)}
        />
      )}
      <div className="bg-white rounded-2xl w-full overflow-hidden flex flex-col" style={{ maxWidth: '440px', maxHeight: '95vh' }} onClick={(e) => e.stopPropagation()}>

        {step === 1 && (
          <Step1DateTime
            doctor={doctor}
            onBack={onClose}
            onClose={onClose}
            onNext={(b) => { setBooking(b); setStep(2); }}
          />
        )}

        {step === 2 && (
          <Step2PatientDetails
            doctor={doctor}
            booking={booking}
            onBack={() => setStep(1)}
            onClose={onClose}
            onNext={(p) => {
              setPatient(p);
              if (user?.isVerified) {
                setStep(4);
              } else {
                setStep(3);
              }
            }}
            notify={notify}
          />
        )}

        {step === 3 && (
          <Step3OTP
            doctor={doctor}
            booking={booking}
            patient={patient}
            onBack={() => setStep(2)}
            onClose={onClose}
            onVerified={() => setStep(4)}
            notify={notify}
          />
        )}

        {step === 4 && (
          <Step4Payment
            doctor={doctor}
            booking={booking}
            onClose={onClose}
            onDone={({ paymentStatus: ps }) => {
              setPaymentStatus(ps);
              setDone(true);
            }}
          />
        )}

      </div>
    </div>
  );
};

/* ── Small pieces (unchanged) ── */
const Stat = ({ label, value, note, isRating, isAvailability, available }) => (
  <div className="flex flex-col gap-0.5">
    <span className="ava-text-xs">{label}</span>
    <div className="flex items-center gap-1">
      {isRating && <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--ava-color-success-base)"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>}
      <span className="ava-text-body" style={{ color: isAvailability ? (available ? 'var(--ava-color-success-base)' : 'var(--ava-color-error-base)') : 'var(--primary-color)' }}>{value}</span>
    </div>
    {note && <span className="ava-text-xs">({note})</span>}
  </div>
);

const PinIcon = ({ small }) => (
  <svg width={small ? 12 : 14} height={small ? 12 : 14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--text-light)', flexShrink: 0 }}>
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export default BookAppointment;
